import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import QRCode from 'qrcode.react';

import FindFormComponent from './FindFormComponent';
import * as action from '../../actions';
import * as selector from '../../selectors';

const mapStateToProps = state => ({
	form: selector.getCardFindForm(state),
	info: selector.getCardInfo(state),
});
const mapDispatchToProps = dispatch => bindActionCreators({
	findCard: action.findCard.request,
	clearCardInfo: action.clearCardInfo,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		info: PropTypes.object,
		form: PropTypes.object,
		findCard: PropTypes.func,
		clearCardInfo: PropTypes.func,
	};

	componentWillUnmount() {
		const {clearCardInfo} = this.props;
		clearCardInfo();
	}

	onSubmit = (props, onFailure) => {
		const {findCard} = this.props;
		findCard({
			form: props,
			onFailure,
		});
	};

	render() {
		const {
			info: {name, link},
			form: {loading},
		} = this.props;

		return (
			<div className="cards cards-find">
				{!name && (
					<div className="cards-form">
						<div className="header">Установить электронную карту</div>
						<p>
							Введите данные вашей карты гостя для установки электронной карты:
						</p>
						<hr />
						<FindFormComponent
							like={false}
							loading={loading}
							onSubmit={this.onSubmit}
						/>
					</div>
				)}
				{name && (
					<div className="cards-info">
						<div className="header">Здравствуйте,<br />{name}!</div>
						{link && (
							<Fragment>
								<p>
									Добавьте карту гостя себе в Apple Wallet,<br />
									нажав на кнопку ниже:
								</p>
								<div className="apple-wallet-btn">
									<a href={link} target="_blank">
										<img src="https://hookah.name/images/Add_to_Apple_Wallet_rgb_RU.svg" alt="Add to Apple Wallet" />
									</a>
								</div>
								<p>
									или просканировав QR код с вашего телефона:
								</p>
								<div className="qr-code-wrapper">
									<QRCode value={link} className="qr-code" />
								</div>
							</Fragment>
						)}
						{!link && (
							<div>
								Электронная карта недоступна.
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/card/FindCard.js